import QuestionPage from '@app-studio-web/ui/pages/QuestionPage'
import { useTranslation } from 'react-i18next'
import { useSubmit } from 'react-router-dom'

export default function QuestionChallengePage() {
  const submit = useSubmit()
  const { t } = useTranslation()

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    submit(event.currentTarget)
  }

  return (
    <QuestionPage
      heading={t('pages.onboarding.questionChallenge.heading')}
      buttons={[
        {
          text: t('pages.onboarding.questionChallenge.button1'),
          value: 'not_enough_time',
        },
        {
          text: t('pages.onboarding.questionChallenge.button2'),
          value: 'cant_think_what_to_make',
        },
        {
          text: t('pages.onboarding.questionChallenge.button3'),
          value: 'missing_ingredients',
        },
        {
          text: t('pages.onboarding.questionChallenge.button4'),
          value: 'lack_skills',
        },
      ]}
      onSubmit={handleSubmit}
    />
  )
}
